"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _reactIntl = require("react-intl");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/DateRange/lib/DateRange.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function cov_28x0kslmt9() {
  var path = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/DateRange/lib/DateRange.js";
  var hash = "69665eae7b995ef601fffaa04f11f403f4053ca9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/DateRange/lib/DateRange.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 19
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 94,
          column: 1
        }
      },
      "3": {
        start: {
          line: 35,
          column: 19
        },
        end: {
          line: 35,
          column: 33
        }
      },
      "4": {
        start: {
          line: 36,
          column: 17
        },
        end: {
          line: 36,
          column: 29
        }
      },
      "5": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 73
        }
      },
      "6": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 81
        }
      },
      "7": {
        start: {
          line: 42,
          column: 19
        },
        end: {
          line: 42,
          column: 78
        }
      },
      "8": {
        start: {
          line: 44,
          column: 29
        },
        end: {
          line: 44,
          column: 53
        }
      },
      "9": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 66,
          column: 3
        }
      },
      "10": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 84
        }
      },
      "11": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "12": {
        start: {
          line: 54,
          column: 9
        },
        end: {
          line: 66,
          column: 3
        }
      },
      "13": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 98
        }
      },
      "14": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 58,
          column: 6
        }
      },
      "15": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "16": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 65,
          column: 6
        }
      },
      "17": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 93,
          column: 4
        }
      },
      "18": {
        start: {
          line: 97,
          column: 0
        },
        end: {
          line: 103,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 18
          },
          end: {
            line: 25,
            column: 19
          }
        },
        loc: {
          start: {
            line: 25,
            column: 50
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 25
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 30
          }
        }, {
          start: {
            line: 40,
            column: 34
          },
          end: {
            line: 40,
            column: 81
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 19
          },
          end: {
            line: 42,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 19
          },
          end: {
            line: 42,
            column: 29
          }
        }, {
          start: {
            line: 42,
            column: 33
          },
          end: {
            line: 42,
            column: 78
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        }, {
          start: {
            line: 54,
            column: 9
          },
          end: {
            line: 66,
            column: 3
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 49,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 49,
            column: 15
          }
        }, {
          start: {
            line: 49,
            column: 19
          },
          end: {
            line: 49,
            column: 29
          }
        }],
        line: 49
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 9
          },
          end: {
            line: 66,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 9
          },
          end: {
            line: 66,
            column: 3
          }
        }, {
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 66,
            column: 3
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 54,
            column: 13
          },
          end: {
            line: 54,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 13
          },
          end: {
            line: 54,
            column: 24
          }
        }, {
          start: {
            line: 54,
            column: 28
          },
          end: {
            line: 54,
            column: 37
          }
        }],
        line: 54
      },
      "6": {
        loc: {
          start: {
            line: 70,
            column: 7
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 7
          },
          end: {
            line: 70,
            column: 15
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 80,
            column: 12
          }
        }],
        line: 70
      },
      "7": {
        loc: {
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 91,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 83,
            column: 16
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 90,
            column: 12
          }
        }],
        line: 83
      },
      "8": {
        loc: {
          start: {
            line: 86,
            column: 13
          },
          end: {
            line: 86,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 13
          },
          end: {
            line: 86,
            column: 31
          }
        }, {
          start: {
            line: 86,
            column: 35
          },
          end: {
            line: 86,
            column: 89
          }
        }],
        line: 86
      },
      "9": {
        loc: {
          start: {
            line: 88,
            column: 13
          },
          end: {
            line: 88,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 13
          },
          end: {
            line: 88,
            column: 32
          }
        }, {
          start: {
            line: 88,
            column: 36
          },
          end: {
            line: 88,
            column: 40
          }
        }],
        line: 88
      },
      "10": {
        loc: {
          start: {
            line: 89,
            column: 13
          },
          end: {
            line: 89,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 13
          },
          end: {
            line: 89,
            column: 31
          }
        }, {
          start: {
            line: 89,
            column: 34
          },
          end: {
            line: 89,
            column: 86
          }
        }],
        line: 89
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "69665eae7b995ef601fffaa04f11f403f4053ca9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28x0kslmt9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28x0kslmt9();
var Capitalize = (cov_28x0kslmt9().s[0]++, _styledComponents.default.span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-transform: capitalize;\n"]))));
var DateRangeWrapper = (cov_28x0kslmt9().s[1]++, _styledComponents.default.div.attrs({
  className: 'g-DateRange-wrapper'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  p.semantic-no-styling {\n    margin: 0;\n  }\n"]))));

/**
 * Component to display a range of date, it is adapted to avoid repeating day, month or year if it is the same
 */
cov_28x0kslmt9().s[2]++;
var DateRange = function DateRange(_ref) {
  var from = _ref.from,
    to = _ref.to,
    themeQueries = _ref.themeQueries;
  cov_28x0kslmt9().f[0]++;
  // const SAME_DAY = isSameDay(from, to);
  // const SAME_MONTH = isSameMonth(from, to);
  // const SAME_YEAR = isSameYear(from, to);
  // isSameDay compare 2 dates inside local timezone but we display UTC timezone
  // For example:
  // from: 2018-03-13T21:00:00.000Z
  // to: 2018-03-13T23:00:00.000Z
  // isSameDay return false in CH timezone (GMT +1)

  var fromDate = (cov_28x0kslmt9().s[3]++, new Date(from));
  var toDate = (cov_28x0kslmt9().s[4]++, new Date(to));
  // Is it the same year
  var SAME_YEAR = (cov_28x0kslmt9().s[5]++, fromDate.getUTCFullYear() === toDate.getUTCFullYear());
  // Is it the same month of the same year
  var SAME_MONTH = (cov_28x0kslmt9().s[6]++, (cov_28x0kslmt9().b[0][0]++, SAME_YEAR) && (cov_28x0kslmt9().b[0][1]++, fromDate.getUTCMonth() === toDate.getUTCMonth()));
  // is it the same day of the same month of the same year
  var SAME_DAY = (cov_28x0kslmt9().s[7]++, (cov_28x0kslmt9().b[1][0]++, SAME_MONTH) && (cov_28x0kslmt9().b[1][1]++, fromDate.getUTCDate() === toDate.getUTCDate()));
  var isEquilibriumTheme = (cov_28x0kslmt9().s[8]++, themeQueries.EQUILIBRIUM);
  var formattedFromDate;
  var formattedToDate;
  cov_28x0kslmt9().s[9]++;
  if ((cov_28x0kslmt9().b[3][0]++, !SAME_DAY) && (cov_28x0kslmt9().b[3][1]++, SAME_MONTH)) {
    cov_28x0kslmt9().b[2][0]++;
    cov_28x0kslmt9().s[10]++;
    formattedFromDate = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
      value: from,
      day: "numeric",
      timeZone: "UTC",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 25
      }
    });
    cov_28x0kslmt9().s[11]++;
    formattedToDate = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
      value: to,
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 7
      }
    });
  } else {
    cov_28x0kslmt9().b[2][1]++;
    cov_28x0kslmt9().s[12]++;
    if ((cov_28x0kslmt9().b[5][0]++, !SAME_MONTH) && (cov_28x0kslmt9().b[5][1]++, SAME_YEAR)) {
      cov_28x0kslmt9().b[4][0]++;
      cov_28x0kslmt9().s[13]++;
      formattedFromDate = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: from,
        day: "numeric",
        month: "short",
        timeZone: "UTC",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 25
        }
      });
      cov_28x0kslmt9().s[14]++;
      formattedToDate = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: to,
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 7
        }
      });
    } else {
      cov_28x0kslmt9().b[4][1]++;
      cov_28x0kslmt9().s[15]++;
      formattedFromDate = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: from,
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 7
        }
      });
      cov_28x0kslmt9().s[16]++;
      formattedToDate = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: to,
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64,
          columnNumber: 7
        }
      });
    }
  }
  cov_28x0kslmt9().s[17]++;
  return /*#__PURE__*/_react.default.createElement(DateRangeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 5
    }
  }, (cov_28x0kslmt9().b[6][0]++, SAME_DAY) && (cov_28x0kslmt9().b[6][1]++, /*#__PURE__*/_react.default.createElement("p", {
    className: "semantic-no-styling",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    value: from,
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 11
    }
  }))), (cov_28x0kslmt9().b[7][0]++, !SAME_DAY) && (cov_28x0kslmt9().b[7][1]++, /*#__PURE__*/_react.default.createElement("p", {
    className: "semantic-no-styling",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(Capitalize, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 11
    }
  }, (cov_28x0kslmt9().b[8][0]++, isEquilibriumTheme) && (cov_28x0kslmt9().b[8][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: 'gravity.DateRange.from',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 36
    }
  })), " ", formattedFromDate, ' '), (cov_28x0kslmt9().b[9][0]++, !isEquilibriumTheme) && (cov_28x0kslmt9().b[9][1]++, '- '), (cov_28x0kslmt9().b[10][0]++, isEquilibriumTheme) && (cov_28x0kslmt9().b[10][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: 'gravity.DateRange.to',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 35
    }
  })), " ", formattedToDate)));
};
cov_28x0kslmt9().s[18]++;
DateRange.propTypes = {
  /** the first date */
  from: _propTypes.default.string.isRequired,
  /** the last date */
  to: _propTypes.default.string.isRequired,
  themeQueries: _utils.WithThemeQueriesType
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(DateRange));